import { ProductionDocument } from '../Productions/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, push, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import {
  AdvanceDocument,
  advancesPullQueryBuilder,
  advancesPushQueryBuilder,
} from './queryBuilder';

export function borerShiftAdvanceFamilyMember(
  configBuilder: ConfigBuilder,
  borerShiftProduction: FamilyMember<ProductionDocument>,
): FamilyMember<AdvanceDocument> {
  const syncConfig = configBuilder<AdvanceDocument>(RxdbCollectionNameV2.BORER_SHIFT_ADVANCE);
  doNotAutoSync(syncConfig);

  pull(syncConfig, advancesPullQueryBuilder);
  push(syncConfig, advancesPushQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.BORER_SHIFT_ADVANCE, replicationState, [borerShiftProduction]);
}
